@let view = data();

@if (view.headline) {
  <h2>{{ view.headline }}</h2>
}

<div class="wrapper-teasers">
  @for (item of view.items; track item) {
    <ui-service-teaser
      [data]="item"
    ></ui-service-teaser>
  }
</div>
